import styled from 'styled-components'
import { tokens } from 'styling/tokens'

interface NavBarWrapperProps {
  sidebar?: boolean
  st?: string
}

export const NavBarWrapper = styled.nav<NavBarWrapperProps>`
  position: fixed;
  top: 1rem;
  right: 1rem;
  height: 4rem;
  left: ${({ sidebar }) => (sidebar ? '15rem' : '5rem')};
  transition: all 0.5s ease-in-out;
  border-radius: ${tokens.radius.card};
    display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;

  @media (max-width: 1024px) {
    left: 1rem;
    gap: 0.75rem;
    justify-content: flex-start;

    .user {
      margin-left: auto;
    }
  }
  form {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  z-index: 9999;
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${tokens.border.hairline};
  box-shadow: ${tokens.shadow.card};
  ${({ st }) => st}
`

export const NavBarHamburger = styled.button`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    border-radius: ${tokens.radius.control};
    border: 1px solid ${tokens.accent.base};
    background: ${tokens.accent.soft};
    color: ${tokens.accent.base};
    cursor: pointer;
    transition: filter 0.2s ease;

    &:hover {
      filter: brightness(115%);
    }

    span {
      display: block;
      width: 18px;
      height: 2px;
      border-radius: 2px;
      background: currentColor;
    }
  }
`

export const NavBarInput = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  .icons{
    margin-right: 1rem;
    display: flex;
    gap: 5px;

  }
  input {
    height: 1.3rem;
    width: 15.6rem;
    background-color: transparent;
    border: none;
    outline: none;
    text-transform: capitalize;

    font-size: 1rem;
    line-height: 1.3rem;
    color: ${tokens.text.primary};

    &::placeholder{
      color: ${tokens.text.muted};
    }
  }
  button {
    color: ${tokens.text.secondary};
    background-color: transparent;
    border: none;
  }
  svg {
    width: 24px;
    height: 24px;
  }
`
export const NavBarUser = styled.div`


  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  h3 {
    font-weight: 500;
    font-size: 0.9rem;
    line-height: 1.3rem;
    text-align: right;
    color: ${tokens.text.primary};
  }
  p {
    font-weight: 400;
    font-size: 0.8rem;
    line-height: 1.2rem;
    text-align: right;
    color: ${tokens.text.muted};
  }
`

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
`

export const UserButtonsContiner = styled.div`
  display: flex;
  gap: 1rem;
  padding: 5px;
  width: 0%;
  overflow: hidden;
  animation: widen 0.8s ease forwards;

  @keyframes widen {
    0% {
      width: 0%;
    }
    100% {
      width: 100%;
    }
  }
`

export const NavBarFilterContainer = styled.div`
  display: flex;
`

export const NavBarFilterSelect = styled.select`
  border: none;

  font-weight: 700;
  font-size: 0.7rem;
  line-height: 1rem;
  text-transform: capitalize;
  color: ${tokens.text.secondary};
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
`

export const NavBarFilterOption = styled.option`
  font-weight: 700;
  font-size: 0.7rem;
  line-height: 1rem;
  text-transform: capitalize;
  color: ${tokens.text.secondary};
  border: none;
  border-radius: 0%;
  margin-top: 0.3rem;
  padding: 0.3rem;
`
interface ProfileProps {
  show?: boolean
}
export const Profile = styled.div<ProfileProps>`
  display: flex;
  align-items: center;
  gap: ${({ show }) => (show ? '1rem' : '0.5rem')};
  transition: all 0.5s ease-in-out;
`
interface ShowLogoutProps {
  show?: boolean
}

export const UserBtn = styled.div<ShowLogoutProps>`
  border-radius: 10px;
  background-color: ${tokens.surface.inset};
  padding: 10px;
  display: flex;
  width: 70px;
  height: 2.5rem;
  align-items: center;
  justify-content: center;
  transform: ${(props) => (props.show ? 'translate(0)' : 'translate(130px)')};
  color: white;
  cursor: pointer;
  transition: all 0.5s ease-in;
`
export const UserOptionsContainer = styled.div<ShowLogoutProps>`
  width:250px;
  border-radius: ${tokens.radius.card};
  position: fixed;
  top: 6rem;
  right: 2rem;
  transition: .2s ease-in-out;
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${tokens.border.hairline};
  box-shadow: ${tokens.shadow.card};
  padding: 1rem ;
  z-index: 999999999999999999;

  p {
    color: ${tokens.text.primary};
  }
  `